import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Table from '../../ui/Table';
import Tag from '../../ui/Tag';
import { ValidationOverviewData } from '../../constants/validationOverviewData';
import Heading from '../../ui/Heading';
import SortIcon from '../../assets/icons/SortIcon';
import { getBounty, getBountySubmissions, getUnvalidatedBounties } from '../../apis/bounties/bounties';
import { useEffect, useState } from 'react';
import WhiteCard from '../../ui/WhiteCard';
import StatsCard from '../../ui/StatsCard';
import IssuedIcon from '../../assets/icons/IssuedIcon';
import NotIssuedIcon from '../../assets/icons/NotIssuedIcon';

import Legend from '../../ui/Legend';
import Button from '../../ui/Button';
import { maxDate } from '../../helpers/maxDate';
import NoDataAvailable from '../../ui/NoDataAvailable';
import Loader from '../../ui/Loader';
import { FirstRank, SecondRank, ThirdRank } from '../../assets/icons/RankIcons';
import useLocalStorage from '../../hooks/useLocalStoarge';
import { formatIntDateAndThenTime } from '../../helpers/formatInDateAndThenTime';
import Pagination from '../../ui/Pagination';
import { requestFundTransfer } from '../../apis/validator/validating';
import AvatarImage from '../../ui/AvatarImage';

const rank = {
    1: <FirstRank />,
    2: <SecondRank />,
    3: <ThirdRank />,
};

function ValidationBountySubmission() {
    const { bountyId, id } = useParams();
    const [bountyDetails, setBountyDetails] = useState({});
    const [isVisible, setIsVisible] = useState(false);

    const handleMouseEnter = () => {
        setIsVisible(true);
    };
    const handleMouseLeave = () => {
        setIsVisible(false);
    };
    const [isLoading, setIsLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);
    const navigate = useNavigate();

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    const [response1, response2] = await Promise.all([
                        getBountySubmissions(bountyId),
                        getUnvalidatedBounties(id, 1, 100),
                    ]);

                    const extractedBounty = response2.find((bounty) => bounty._id === bountyId);

                    setIsLoading(false);
                    setSubmissions(response1);

                    // const maxUpdateTime = maxDate(response1.map((submission) => submission?.updatedAt));
                    // console.log(response1, response2, extractedBounty, 'response1,response2');
                    setBountyDetails(() => ({ ...extractedBounty }));
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [bountyId, id]
    );

    const currentTotal = submissions.length;
    const scoresCount = submissions.filter((submission) => submission.accuracy).length;
    const { status } = bountyDetails;

    const shouldDisable =
        submissions.length !== scoresCount || submissions.length === 0 || status?.toLowerCase() !== 'unvalidated';

    const onRequestingFundTransfer = async () => {
        try {
            const response = await requestFundTransfer(bountyId);

            if (response?.success) {
                navigate(-1);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <div className="my-6">
                <p>Bounty Title :</p>

                <Heading type={'large'} className={'text-lightBlack font-medium '}>
                    {bountyDetails?.title}
                </Heading>
            </div>
            <div className="flex justify-between items-end  ">
                <WhiteCard verticalMargin="" className="w-fit p-6 ">
                    <p className="font-semibold mb-2">Submissions</p>
                    <div className="flex items-center gap-4 ">
                        <StatsCard countHeading={'Current Total'} count={currentTotal} />
                        <StatsCard countHeading={'Not Scored'} count={currentTotal - scoresCount} />
                        <StatsCard countHeading={'Scored'} count={scoresCount} />
                    </div>
                </WhiteCard>

                {status?.toLowerCase() !== 'completed' &&
                    status?.toLowerCase() !== 'validation requested' &&
                    bountyDetails?.validationType !== 'AFTER_EACH_SUBMISSION' &&
                    !bountyDetails?.raisedFunding && (
                        <div>
                            <p className="mb-2">Propose Validation</p>
                            <div className="relative">
                                <Button
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    data-tooltip-target="tooltip-left"
                                    data-tooltip-placement="left"
                                    type="button"
                                    onClick={() => {
                                        if (shouldDisable) return;
                                        navigate(`request`);
                                    }}
                                    className={` pl-5 pr-5 ${shouldDisable ? 'cursor-not-allowed' : ' '} `}
                                    // disabled={shouldDisable}
                                    size="fit"
                                >
                                    Finalise Grading
                                </Button>

                                <div
                                    id="tooltip-left"
                                    role="tooltip"
                                    style={{
                                        top: '50%',
                                        right: '100%',
                                        transform: 'translateY(-50%)',
                                    }}
                                    className={`absolute z-10 mr-3 w-[494px]  px-4 py-2 transition-opacity duration-300 ${
                                        isVisible && shouldDisable ? 'opacity-100 visible' : 'opacity-0 invisible'
                                    } text-sm font-medium text-primaryInput border border-borderColor bg-white rounded-[4px] shadow-sm opacity-0 tooltip  `}
                                >
                                    <p className="text-sm">
                                        Validation can be requested only after the bounty expires on &nbsp;
                                        {formatIntDateAndThenTime(bountyDetails?.expirationTimestamp)} and when all
                                        submissions have been validated.
                                    </p>
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </div>
                    )}
                {status?.toLowerCase() !== 'completed' &&
                    status?.toLowerCase() !== 'validation requested' &&
                    bountyDetails?.validationType !== 'AFTER_EACH_SUBMISSION' &&
                    bountyDetails?.raisedFunding && (
                        <div>
                            <div className="relative">
                                <Button
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    data-tooltip-target="tooltip-left"
                                    data-tooltip-placement="left"
                                    type="button"
                                    onClick={() => {
                                        if (shouldDisable) return;
                                        onRequestingFundTransfer();
                                    }}
                                    className={` pl-5 pr-5 ${shouldDisable ? 'cursor-not-allowed' : ' '} `}
                                    // disabled={shouldDisable}
                                    size="fit"
                                >
                                    Request Fund Transfer
                                </Button>

                                <div
                                    id="tooltip-left"
                                    role="tooltip"
                                    style={{
                                        top: '50%',
                                        right: '100%',
                                        transform: 'translateY(-50%)',
                                    }}
                                    className={`absolute z-10 mr-3 w-[494px]  px-4 py-2 transition-opacity duration-300 ${
                                        isVisible && shouldDisable ? 'opacity-100 visible' : 'opacity-0 invisible'
                                    } text-sm font-medium text-primaryInput border border-borderColor bg-white rounded-[4px] shadow-sm opacity-0 tooltip  `}
                                >
                                    <p className="text-sm">
                                        Please evaluate all submissions before requesting for transfer of funds
                                    </p>
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </div>
                    )}
            </div>

            <Table className=" items-center gap-8 " cols="grid-cols-12">
                <Table.Header>
                    <p className="text-sm col-span-3  font-semibold text-secondaryText "> Username </p>
                    <p className="text-sm col-span-4  font-semibold text-secondaryText "> Submission ID </p>
                    <p className="text-sm justify-self-center col-span-2  font-semibold text-secondaryText ">Score</p>
                    <p className="text-sm col-span-3  font-semibold text-secondaryText ">Impact Certificate</p>
                </Table.Header>
                {isLoading ? (
                    <div className="min-h-[20vh] flex justify-center items-center">
                        <Loader />
                    </div>
                ) : submissions.length ? (
                    submissions.map((submission, index) => (
                        <Table.Row key={submission.submissionId}>
                            <div
                                onClick={() => navigate(submission.submissionId)}
                                className=" col-span-3 flex items-center cursor-pointer  justify-self-start   "
                            >
                                <div className="flex items-center gap-1 ">
                                    <AvatarImage w="w-6" h="h-6" url={submission?.submitterProfileImage} />
                                    <p className="text-primaryInput  ">{submission?.submitterUsername}</p>
                                </div>
                            </div>
                            <p
                                onClick={() => navigate(submission.submissionId)}
                                className=" col-span-4 text-primaryColor flex items-center cursor-pointer  uppercase justify-self-start font-medium  "
                            >
                                <span className="truncate ">{submission.submissionId} </span>{' '}
                                {submission?.accuracy && bountyDetails?.validationType !== 'AFTER_EACH_SUBMISSION' ? (
                                    submission?.accuracy * 100 >= bountyDetails?.passThreshold * 100 ? (
                                        <span>{index + 1 <= 3 && rank[index + 1]}</span>
                                    ) : null
                                ) : null}
                            </p>
                            <p className="justify-self-center col-span-2 text-primaryInput  ">
                                {submission?.accuracy >= 0 ? (Number(submission.accuracy) * 100).toFixed(2) : '-'}
                            </p>
                            <p className="col-span-3 ">
                                {submission?.impactCertificateIssued || submission?.issueImpactCertificate ? (
                                    <IssuedIcon />
                                ) : (
                                    <NotIssuedIcon />
                                )}
                            </p>
                        </Table.Row>
                    ))
                ) : (
                    <NoDataAvailable />
                )}
                {/* <Pagination count={100} PAGE_SIZE={10} /> */}
                <div className="flex items-center justify-end mt-6">
                    <div className="flex items-center gap-3 ">
                        <p className="text-sm font-bold">Impact Certificate</p>
                        <Legend shield={<NotIssuedIcon />} text={'Not Issued'} />
                        <Legend shield={<IssuedIcon />} text={'Issued'} />
                    </div>
                </div>
            </Table>
        </div>
    );
}

export default ValidationBountySubmission;

// submissions.length === scoresCount && status?.toLowerCase() === 'unvalidated' &&
// {submission?.accuracy ? (
//     submission?.accuracy * 100 >= 40 ? (
//         <span>{index + 1 <= 3 && rank[index + 1]}</span>
//     ) : null
// ) : null}

// const payload = {
//     title: overviewrow.title,
//     projectTitle: overviewrow.projectTitle,
//     startDate: overviewrow.startTimestamp,
//     endDate: overviewrow.expirationTimestamp,
//     totalSubmissions: unvalidatedBounties.length,
//     status: overviewrow.status,
//     hasImpactCertificate: overviewrow?.hasImpactCertificate,
//     passThreshold: overviewrow?.passThreshold,
//     validationType: overviewrow?.validationType,
//     raisedFunding: overviewrow?.raisedFunding,
// };
// handleBountyDetails(payload);
